const AutoSaveIndicator = () => null;

export default AutoSaveIndicator;
